/* eslint-disable no-unreachable */
// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import MagnifyIcon from '@material-ui/icons/Search';
import SecondaryButton from '../../../view/common/component/SecondaryButton';

import AnalyticsBase from '../AnalyticsBase';
import AnalyticsFilterBar from '../AnalyticsFilterBar';
import BreadcrumbNav from '../../nav/BreadcrumbNav';
import EmptyState from '../../common/EmptyState';

import { initializeAnalytics } from '../../../state/reducer/analytics/actionCreators/initializeAnalytics';
import * as DateUtils from '../../../lib/dateUtils';
import * as AnalyticsState from '../../../state/reducer/analytics/analytics';
import loadMarketplaceProducts from '../../../state/reducer/analytics/actionCreators/loadMarketplaceProducts';
import KPIBar from '../KPIBar';
import Console from '../../../lib/debug';

type Props = {
    match: any,
    dispatch: any => void
};

const PAGE_KEY = 'marketplace-attributions';
const DEFAULT_SEARCH_DATE_OFFSET = 30;

class AttributionsReportingView extends Component<Props> {
    constructor(props: Props) {
        super(props);
        loadMarketplaceProducts(this.props.dispatch);
        this.loadAnalytics();
    }

    componentDidUpdate(prevProps: {}, prevState: {}) {
        this.loadAnalytics();
    }

    loadAnalytics() {
        const dataParams = this.getDataParams();

        this.props.dispatch(
            initializeAnalytics(
                PAGE_KEY,
                dataParams,
                '/v5/analytics/attributions/team'
            )
        );
    }

    getStartDate = () => {
        const dataParams = this.getDataParams();
        return moment(dataParams.date_start);
    };

    getEndDate = () => {
        const dataParams = this.getDataParams();
        return moment(dataParams.date_end);
    };

    setSearchParams = (params: {}) => {
        const existingParams = AnalyticsState.getSearchParams();
        AnalyticsState.updateSearchParams({
            ...existingParams,
            ...params
        });
    };

    getDataParams = () => {
        const searchParams = AnalyticsState.getSearchParams();

        let endDate = searchParams.end_date;
        if (!DateUtils.isValidDateString(endDate)) {
            endDate = moment();
            endDate = moment(endDate, DateUtils.CALENDAR_FORMAT);
        }

        let startDate = searchParams.start_date;
        if (!DateUtils.isValidDateString(startDate)) {
            startDate = moment(endDate).subtract(
                DEFAULT_SEARCH_DATE_OFFSET,
                'd'
            );
            startDate = moment(startDate, DateUtils.CALENDAR_FORMAT);
        }

        let teamId = parseInt(searchParams.team_id, 10);
        let team_id = null;
        if (!teamId || typeof teamId !== 'number') {
            team_id = null;
        } else {
            team_id = teamId;
        }

        return {
            date_start: moment(startDate).format(DateUtils.CALENDAR_FORMAT),
            date_end: moment(endDate).format(DateUtils.CALENDAR_FORMAT),
            team_id
        };
    };

    getSelectedTeamId = () => {
        const params = this.getDataParams();
        if (params.team_id) {
            return params.team_id;
        }
        return undefined;
    };

    setSearchParams = (params: {}) => {
        const existingParams = AnalyticsState.getSearchParams();
        AnalyticsState.updateSearchParams({
            ...existingParams,
            ...params
        });
    };

    onSelectTeam = (ev: Event, { suggestion }: any) => {
        const team_id = suggestion.id;
        this.setSearchParams({ team_id });
    };

    getInitialState = () => {
        if (this.props.marketplaceProducts.length) {
            return null;
        }

        return (
            <div style={{ paddingTop: 60 }}>
                <EmptyState
                    text="No data to display"
                    icon={<MagnifyIcon style={{ fontSize: 81 }} />}
                />
            </div>
        );
    };

    getPageTitle = () => {
        let title =
            this.props.metaTree &&
            this.props.metaTree.instances &&
            this.props.metaTree.instances[PAGE_KEY] &&
            this.props.metaTree.instances[PAGE_KEY].title;
        if (title) {
            return title;
        }
        return '';
    };

    onSelectDateRange = ({ startDate, endDate }: State) => {
        const formattedStartDate = startDate.format(DateUtils.CALENDAR_FORMAT);
        if (!endDate) {
            this.setSearchParams({
                start_date: formattedStartDate,
                end_date: formattedStartDate
            });
            return;
        }

        this.setSearchParams({
            start_date: formattedStartDate,
            end_date: endDate.format(DateUtils.CALENDAR_FORMAT)
        });
    };

    navigateToShareLinks = () => {
        window.location = '/my-store/attribution-links';
    };

    render() {
        Console.render('AttributionsReportingView');
        const initialState = this.getInitialState();

        const crumbs = [
            {
                displayString: 'Analytics',
                link: `/analytics`,
                editable: false
            },
            {
                displayString: this.getPageTitle(),
                link: null,
                editable: false
            }
        ];

        return (
            <div className="has-filter-bar">
                <BreadcrumbNav crumbs={crumbs} />
                <AnalyticsFilterBar
                    marketplaceProductSelector={{
                        selectedId: this.getSelectedTeamId(),
                        onSelect: this.onSelectTeam,
                        allOptionText: 'All Products'
                    }}
                    dateRangePicker={{
                        startDate: this.getStartDate(),
                        endDate: this.getEndDate(),
                        onChange: this.onSelectDateRange
                    }}
                />
                <AnalyticsBase
                    includeGraph={true}
                    graphLibrary="chart.js"
                    KPIBar={<KPIBar />}
                />
                <div className="table-bottom-button-wrapper">
                    <SecondaryButton
                        variant="outlined"
                        onClick={this.navigateToShareLinks}
                    >
                        View and Edit Channels
                    </SecondaryButton>
                </div>
                {initialState}
            </div>
        );
    }
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        ...ownProps,
        metaTree: state.analytics.metaTree,
        title: state.analytics.title,
        marketplaceProducts: state.analytics.marketplaceProducts
    };
};

export default connect(mapStateToProps)(AttributionsReportingView);



// WEBPACK FOOTER //
// ./src/view/analytics/attributions/AttributionsReportingView.jsx